import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LocaleConverterPipe } from './locale-converter.pipe';



@NgModule({
  declarations: [LocaleConverterPipe],
  imports: [
    CommonModule
  ],
  exports: [
    LocaleConverterPipe
  ]
})
export class LocaleConverterModule { }
